<template>
    <div>
        <div class="text-center text-muted small" v-if="exams.length==0">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-xl-8">
                    <!-- Image -->
                    <img
                        src="@/assets/img/illustrations/coworking.svg"
                        alt="..."
                        class="img-fluid mt-n5 mb-4"
                        style="max-width: 272px;"
                    />
                    <h2>{{ $t('Tooth does not have any exams yet') }}</h2>
                    <p class="text-muted">{{ $t('Start examing tooth by clicking "New exam"') }}</p>

                    <div v-if="newAction">
                        <button class="btn mb-2 btn-outline-primary" @click="newAction()">
                            <i class="fe fe-plus"/>
                            {{ $t('New exam') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="mb-3" v-if="exams.length>0">
                <button class="btn mb-2 btn-outline-primary" v-if="newAction && tooth" @click="newAction()">
                    <i class="fe fe-plus"/>
                    {{ $t('New exam') }}
                </button>
            </div>
            <div v-for="(exam, examIdx) in exams" :key="examIdx">
                <duplicate-popover :target="'exam-' + exam._id" :exam="exam" :action="duplicate"/>
                <div
                    class="card card-inactive p-4 text-center text-muted small"
                    v-if="exam.treatments.length==0"
                >{{ $t('Nothing yet') }}
                </div>
                <div class="card pointer mb-2">
                    <div class="card-header p-2" style="height: auto;">
                        <div class="row align-items-center">
                            <div class="col-auto" @click="toggleCurrentExam(exam);">
                                <i class="fe fe-chevron-down" v-if="currentExam._id == exam._id"/>
                                <i class="fe fe-chevron-right" v-else/>
                            </div>
                            <div class="col-auto">
                                <editable-user v-model="exam.userId" @input="setCurrentExam({...exam, userId: $event}); saveAction()"></editable-user>
                            </div>
                            <!-- <div class="col-auto">{{exam.treatments.length}}</div> -->
                            <div class="col d-none d-lg-block"></div>
                            <div class="col-12 col-md col-lg-auto">
                                <div class="row text-right">
                                    <div class="col align-self-center">{{ exam.createdAt | moment('calendar') }}</div>
                                    <div class="col-12 col-lg-auto">
                                        <confirmable-button
                                            style="display:inline-block"
                                            class="btn-sm mr-2"
                                            v-b-tooltip
                                            @confirm="remove(exam)"
                                            :title="$t('Remove')"
                                        >
                                            <i class="fe fe-trash"></i>
                                        </confirmable-button>

                                        <button
                                            v-if="tooth"
                                            class="btn btn-outline-secondary btn-sm mr-2"
                                            @click="newAction(exam)"
                                            :title="$t('Edit')"
                                            v-b-tooltip.hover
                                        >
                                            <i class="fe fe-edit"></i>
                                        </button>
                                        <button
                                            :id="`exam-${exam._id}`"
                                            class="btn btn-outline-info btn-sm mr-2"
                                            :title="$t('Duplicate to tooth')"
                                            v-b-tooltip.hover
                                        >
                                            <i class="fe fe-copy"></i>
                                        </button>
                                        <button
                                            class="btn btn-sm"
                                            :class="exam.allDone ? 'btn-success':'btn-outline-success'"
                                            @click="toggleAllDone(exam)"
                                            :title="$t('All done')"
                                            v-b-tooltip.hover
                                        >
                                            <i class="fe fe-check"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-3" v-if="currentExam._id == exam._id">
                        <div class="row align-items-start">
                            <div class="col-12 mb-3 col-md-4 col-lg-3 col-xl-2 d-flex justify-content-center flex-column align-items-center">
                                <tooth-parts
									class="mb-3"
									readonly="true"
									width="70"
									:tooth="exam.tooth"
									v-model="exam.parts"
								></tooth-parts>
                                <div class="d-flex justify-content-center align-items-center flex-wrap">
									<span
										class="badge badge-warning badge-pill mr-1 mb-2"
										v-for="condition in exam.condition"
										:key="condition"
									>{{ conditionLabel(condition) }}</span>
								</div>

                                <!-- <div class="h4">{{$t('Complaints')}}</div>
                            <ul class="small">
                                <li v-for="cdb in exam.cdb" :key="cdb._id">{{cdb.label}}</li>
                            </ul>
                            <div class="h4">{{$t('Objectively')}}</div>
                            <ul>
                                <li v-for="cdb in exam.cdb" :key="cdb._id">{{cdb.label}}</li>
                            </ul>
                            <div class="h4">{{$t('Diagnosis')}}</div>
                            <ul>
                                <li v-for="diagnosis in exam.diagnosisFinal" :key="diagnosis._id">{{diagnosis.label}}</li>
                                </ul>-->
                            </div>
                            <div class="col-12 col-md">
                                <div v-for="(service, serviceIndex) in exam.treatments" :key="serviceIndex">
                                    <div class="card mb-1" :class="{'card-inactive text-muted':service.done}">
                                        <div class="card-body p-3">
                                            <div class="row align-items-center">
                                                <div class="col">
                                                    <strong>{{ service.code }}</strong>
                                                    - {{ service.label }}
                                                    <div class="row">
                                                        <span
                                                            class="col-auto text-muted small m-0"
                                                        >{{ service.duration }} {{ $t('min') }}</span>
                                                        <span class="col-auto text-muted small m-0">
                                                            <money class="m-0" :value="service.price"></money>
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="col-auto">
                                                    <span
                                                        class="small mr-2"
                                                        v-if="service.done"
                                                    >{{ $t('Done on') }}: {{ service.doneAt | moment('calendar') }}</span>
                                                    <button
                                                        class="btn btn-outline-info mr-1"
                                                        v-if="!service.done"
                                                        @click="setCurrentExam(exam);removeTreatment(serviceIndex)"
                                                    >
                                                        <i class="fe fe-x"></i>
                                                    </button>

                                                    <b-button
                                                        v-if="service.done"
                                                        :variant="service.done ? 'success':'white'"
                                                        @click="setCurrentExam(exam);toggleDone(service)"
                                                    >
                                                        <i
                                                            class="fe"
                                                            :class="{'fe-check':!service.done, 'fe-check-circle':service.done}"
                                                        ></i>
                                                    </b-button>
                                                    <b-button
                                                        v-else
                                                        :variant="service.done ? 'primary':'outline-success'"
                                                        @click="setCurrentExam(exam);toggleDone(service)"
                                                    >
                                                        <i
                                                            class="fe"
                                                            :class="{'fe-check':!service.done, 'fe-check-circle':service.done}"
                                                        ></i>
                                                    </b-button>
                                                </div>
                                            </div>

                                            <div class="mt-4" v-if="service.bundle.length>0">
                                                <div
                                                    class="row mt-1"
                                                    v-for="(bundleItem, bundleIndex) in service.bundle"
                                                    :key="bundleIndex"
                                                >
                                                    <div class="col" v-if="bundleItem.type == 'product'">
                                                        <div class="card m-0 card-inactive" v-if="bundleItem.product">
                                                            <div class="card-body p-2 small">
                                                                <div class="row align-items-center">
                                                                    <div class="col-auto">{{ bundleItem.product.label }}</div>
                                                                    <div class="col"></div>
                                                                    <div
                                                                        class="col-auto text-muted"
                                                                        v-if="bundleItem.product.price"
                                                                    >{{ bundleItem.quantity }} x {{ bundleItem.product.price.retailPrice }}
                                                                    </div>

                                                                    <div class="col-auto">
                                                                        <i
                                                                            class="fe fe-x"
                                                                            @click="setCurrentExam(exam);deleteBundleItem(serviceIndex, bundleIndex)"
                                                                        ></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col" v-if="bundleItem.type == 'service'">
                                                        <div class="card m-0 card-inactive" v-if="bundleItem.service">
                                                            <div class="card-body p-2 small">
                                                                <div class="row align-items-center">
                                                                    <div class="col-auto">{{ bundleItem.service.label }}</div>
                                                                    <div class="col"></div>
                                                                    <div class="col-auto text-muted">
                                                                        <money :value="bundleItem.service.price"/>
                                                                    </div>
                                                                    <div class="col-auto">
                                                                        <i
                                                                            class="fe fe-x"
                                                                            @click="setCurrentExam(exam);deleteBundleItem(serviceIndex, bundleIndex)"
                                                                        ></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row align-items-start mt-3">
                                    <div class="col">
                                        <b-button
                                            class="t-2"
                                            variant="outline-primary"
                                            v-if="!done"
                                            @click="setCurrentExam(exam);openModal({ id: 'TreatmentBrowserModal'  });"
                                        >
                                            <i class="fe fe-activity"></i>
                                            {{ $t('Add treatment') }}
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <treatment-browser v-if="!done" id="TreatmentBrowserModal" :useAction="useTreamentAction"/>
    </div>
</template>
<script>
import Money from '@/components/Money';
import DuplicatePopover from '@/components/Tooth/DuplicatePopover'
import User from '@/components/User';
import ConfirmableButton from '@/components/ConfirmableButton';
import TreatmentLoop from '@/components/TreatmentLoop';
import TreatmentBrowser from '@/components/TreatmentBrowser';
import { mapActions, mapGetters, mapState } from 'vuex';
import ToothParts from "@/components/Tooth/Parts";
import { modalMixins } from '@/mixins/modal.js'
import debounce from 'lodash/debounce';
import conditions from '@/filters/condition.js';
import { conditionsArray } from '@/filters/condition.js';
import TeamSelect from "@/components/TeamSelect";
import EditableUser from "@/components/Tooth/EditableUser";

export default {
    props: ['id', 'customerId', 'tooth', 'done', 'newAction'],
    mixins: [modalMixins],
    components: {
        EditableUser,
        Money,
        ToothParts,
        ConfirmableButton,
        TreatmentLoop,
        TreatmentBrowser,
        DuplicatePopover,
    },
    data() {
        return {
            hideDone: false,
            currentExam: {},
        }
    },
    computed: {
        ...mapGetters('exam', { findExamInStore: 'find' }),
        ...mapGetters('manipulations', { findManipulationsInStore: 'find' }),

        query() {
            // Don't worry, I got this
            let query = {
                customerId: this.customerId,
                tooth: this.tooth,
                $sort: {
                    createdAt: -1
                }
            };
            return query;
        },
        exams() {


            let exams = this.findExamInStore({ query: this.query }).data;
            if (exams.length > 0) {
                this.setCurrentExam(exams[0]);
            }

            return exams;
            // let filtered = JSON.parse(JSON.stringify(exams));
            // let params = { done: true };

            // if (!this.done) {
            //     params = { $or: [{ done: false }, { done: { $exists: false } }] }
            // }
            // return filtered.map(element => {
            //     element.treatments = element.treatments.filter(sift(params));
            //     return element;
            // });
        },
        manipulations() {
            let manipulations = this.findManipulationsInStore({ query: {} }).data;
            return manipulations;
        }
    },

    created() {
        this.find({ query: this.query }).then(result => {
            if (result.total == 0) {
                this.newAction();
            }
        });
    },
    methods: {
        ...mapActions('exam', ['create', 'patch', 'find', 'remove']),
        ...mapActions('cart', { addToCart: 'create', removeFromCart: 'remove' }),
        ...mapActions('manipulations', { fetchManipulations: 'find' }),

        conditionLabel(condition) {
            let conditions = this.$copy(conditionsArray())
            let obj = conditions.find(o => o.value === condition)
            if (!obj)
                return
            return this.$t(`conditionCodes.${ obj.abbr }`);
        },

        toggleAllDone(exam) {

            this.setCurrentExam(exam);
            let promisses = [];
            exam.treatments.forEach(service => {

                if (this.currentExam.allDone === true) {

                    if (!service.cartId) return;
                    let Remove = this.removeFromCart(service.cartId).then(cart => {
                        delete service.cartId;
                        service.done = false;
                        service.doneAt = null;
                    });
                    promisses.push(Remove);
                } else {

                    let Add = this.addToCart({
                        customerId: this.customerId,
                        tooth: this.tooth,
                        tooths: [this.tooth],
                        treatments: service,
                    }).then(cart => {
                        service.cartId = cart._id;
                        service.done = true;
                        service.doneAt = this.$moment();
                    });
                    promisses.push(Add);
                }

            });


            Promise.all(promisses).then(result => {
                this.currentExam.allDone = !this.currentExam.allDone;
                this.saveAction();
            })


        },

        toggleDone(service) {

            if (service.done != true) {
                this.$toasted.global.info({
                    message: this.$t('Item has been done')
                });
                this.addToCart({
                    customerId: this.customerId,
                    tooth: this.tooth,
                    tooths: [this.tooth],
                    treatments: service,
                }).then(cart => {
                    service.cartId = cart._id;
                    this.saveAction();
                });
            } else {
                this.$toasted.global.info({
                    message: this.$t('Item has been undone')
                });
                this.removeFromCart(service.cartId).then(cart => {
                    delete service.cartId;
                    this.saveAction();
                });
            }

            service.done = !service.done;
            service.doneAt = this.$moment();


        },

        saveAction() {
            let promise, successMessage;

            if (this.currentExam._id) {
                promise = this.patch([this.currentExam._id, this.currentExam]);
            } else {
                promise = this.create(this.currentExam);
            }
        },

        toggleCurrentExam(item) {

            if (item._id == this.currentExam._id)
                this.currentExam = {};
            else
                this.setCurrentExam(item);


        },
        setCurrentExam(item) {
            this.currentExam = item;
        },

        removeTreatment(index) {
            this.currentExam.treatments.splice(index, 1);
            this.saveAction();
        },
        useTreamentAction(item) {
            item.done = false;

            this.currentExam.treatments.push(item);
            this.saveAction();
        },
        deleteBundleItem(itemIndex, bundleIndex) {
            this.currentExam.treatments[itemIndex].bundle.splice(bundleIndex, 1);
            this.saveAction();
        },

        deleteExam(exam) {
            this.remove(exam._id);
        },
        duplicate(items) {
            let promises = [];
            let cart = [];
            let exams = [];
            this.currentExam.duplicateTo = items;
            this.saveAction();

            // items.forEach(tooth => {
            //     let exam = this.$copy(this.currentExam);
            //     exam.tooth = tooth;
            //     delete exam._id;
            //     if (!exam.treatments) return;
            //     promises.push(this.create(exam));

            //     // exam.treatments.forEach(treatment => {
            //     //     let row = {
            //     //         customerId: this.customerId,
            //     //         tooth: tooth,
            //     //         treatments: treatment,
            //     //     };
            //     //     setTimeout(i => {
            //     //         promises.push(this.addToCart(row));
            //     //     }, 500);
            //     // });

            // });


            // // this.addToCart(cart);
            // Promise.all(promises).then(r => {
            //     console.log('done');

            // });


        }
    }
}
</script>
